import { render, staticRenderFns } from "./PlayBadge.vue?vue&type=template&id=678d97ce&scoped=true"
import script from "./PlayBadge.vue?vue&type=script&lang=js"
export * from "./PlayBadge.vue?vue&type=script&lang=js"
import style0 from "./PlayBadge.vue?vue&type=style&index=0&id=678d97ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d97ce",
  null
  
)

export default component.exports